import { BrandhubResource } from '@brandhub/types/brandhub';
import Button from '@semcore/ui/button';
import Modal from '@semcore/ui/modal';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { BrandhubResourcesTable } from './BrandhubResourcesTable';

interface BrandhubResourcesModalProps {
  isVisible: boolean;
  isLoading?: boolean;
  onAddResource: (resource: BrandhubResource) => void;
  onClose: () => void;
}

export const BrandhubResourcesModal = ({
  isVisible,
  isLoading,
  onAddResource,
  onClose,
}: BrandhubResourcesModalProps) => {
  const { t } = useTranslation(['common', 'editor']);

  const [selectedResource, setSelectedResource] = useState<BrandhubResource | null>(null);

  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    setSelectedResource(null);
  }, [isVisible]);

  return (
    <Modal
      className="w-3xl max-w-full"
      visible={isVisible}
      onClose={handleClose}>
      <Modal.Title className="mb-4">{t('editor:resources.selectResource')}</Modal.Title>
      <BrandhubResourcesTable
        selectedResource={selectedResource}
        onSelectedResourceChange={setSelectedResource}
      />
      <div className="mt-6 flex items-center gap-3">
        <Button
          data-test="resource-add-button"
          disabled={!selectedResource || isLoading}
          loading={isLoading}
          size="l"
          use="primary"
          onClick={() => {
            if (selectedResource) {
              onAddResource(selectedResource);
            }
          }}>
          {t('editor:resources.addResource')}
        </Button>
        <Button
          data-test="resource-cancel-button"
          disabled={isLoading}
          size="l"
          onClick={handleClose}>
          {t('common:cancel')}
        </Button>
      </div>
    </Modal>
  );
};
